import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { fetchAchievementNotifications, acknowledgeAchievementNotifications } from "@/lib/achievements";

/**
 * Non-intrusive achievement toasts — process wins only, never market outcomes.
 * Mount once in Layout; polls on navigation focus.
 */
export default function AchievementToastListener() {
  const shown = useRef(new Set());

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      try {
        const { items = [] } = await fetchAchievementNotifications();
        if (cancelled || !items.length) return;

        for (const item of items) {
          const key = item.id || item.achievement_id;
          if (shown.current.has(key)) continue;
          shown.current.add(key);
          toast.success(`Achievement earned: ${item.title} ${item.icon || ""}`, {
            duration: 4000,
            description: item.description,
          });
        }
        await acknowledgeAchievementNotifications();
      } catch {
        // silent — achievements are delight, not critical path
      }
    };

    poll();
    const onFocus = () => poll();
    window.addEventListener("focus", onFocus);
    const interval = setInterval(poll, 60000);

    return () => {
      cancelled = true;
      window.removeEventListener("focus", onFocus);
      clearInterval(interval);
    };
  }, []);

  return null;
}
